import { AllPermissions } from '../auth/permissions';
import type {
    ShareAction,
    ShareSettingsCreateScopeState,
    ShareSettingsFormState,
    ShareSettingsViewModel
} from './types';

export const REVOKED_SHARE_ACTION = 'Revoke' as const;
export const SHARE_SETTINGS_MODE = {
    create: 'create',
    update: 'update'
} as const;

export const SHARE_PERMISSION_OPTIONS: { value: ShareAction; labelToken: string }[] = [
    { value: AllPermissions.Read, labelToken: 'actions.read' },
    { value: AllPermissions.Edit, labelToken: 'actions.edit' },
    { value: AllPermissions.Manage, labelToken: 'actions.manage' }
];

export const SHARE_PERMISSION_OPTIONS_WITH_REVOKE: { value: ShareAction; labelToken: string }[] = [
    ...SHARE_PERMISSION_OPTIONS,
    { value: REVOKED_SHARE_ACTION, labelToken: 'form.remove' }
];

export const DEFAULT_SHARE_ACTION: ShareAction = AllPermissions.Edit;

export const DEFAULT_SHARE_SETTINGS: ShareSettingsViewModel = {
    accessLevel: 'open',
    sharedWith: [],
    sharedWithDepartments: [],
    notify: true,
    notifyContacts: []
};

export const DEFAULT_SHARE_SETTINGS_FORM_STATE: ShareSettingsFormState = {
    defaultAction: DEFAULT_SHARE_ACTION,
    actorsToAddToSharedWith: [],
    departmentsToAddToSharedWith: []
};

export const DEFAULT_SHARE_SETTINGS_SCOPE_STATE: ShareSettingsCreateScopeState = {
    mode: SHARE_SETTINGS_MODE.create,
    currentShareSettings: DEFAULT_SHARE_SETTINGS,
    committedShareSettings: DEFAULT_SHARE_SETTINGS,
    shareAccessEntryForEntityRecordOwner: undefined,
    shareAccessEntryForLoggedInUser: undefined,
    backedUpSharedWith: [],
    backedUpSharedWithDepartments: [],
    shareSettingsFormState: DEFAULT_SHARE_SETTINGS_FORM_STATE
};
export const dropdownModifiers = [
    {
        name: 'flip',
        enabled: true
    },
    {
        name: 'offset',
        options: {
            offset: [0, 4]
        }
    }
];
